export default __webpack_public_path__ + "assets/images/g-icon8-1a4df0a6.svg";